import { render, staticRenderFns } from "./FiltrosDnt.vue?vue&type=template&id=068a50a0&scoped=true&"
import script from "./FiltrosDnt.vue?vue&type=script&lang=js&"
export * from "./FiltrosDnt.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosDnt.vue?vue&type=style&index=0&id=068a50a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a50a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068a50a0')) {
      api.createRecord('068a50a0', component.options)
    } else {
      api.reload('068a50a0', component.options)
    }
    module.hot.accept("./FiltrosDnt.vue?vue&type=template&id=068a50a0&scoped=true&", function () {
      api.rerender('068a50a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/FiltrosDnt.vue"
export default component.exports